import React from 'react';
import enhance from './enhance';
import ModelNavLink from '../../Layout/ModelNavLink';
import styles from './styles.module.scss';
import Model from '../Model';
import ModelHeader from '../ModelHeader';
import ModelTemplateHeader from '../ModelTemplateHeader';
import LockedModelHeader from '../ModelHeader/LockedModelHeader';
import ModelPipeline from '../ModelPipeline';
import CartNavLink from '../../Layout/NavLinks/CartNavLink';
import Loading from 'components/Loading';
import Warning from './Warning';

export const SeriesDetail = ({
  chartSticky,
  chartStickyStyle,
  closeChart,
  closeLocalSearch,
  closeSearch,
  collapsedChart,
  hasScrolled,
  headerStyles,
  inReviewView,
  isClosed,
  locked,
  menuOpen,
  modelHasTemplates,
  modelId,
  modelTemplatesLoading,
  nextModelId,
  noTemplates,
  openChart,
  previousModelId,
  scrollTop,
  searchMenuVisibility,
  searchOptions,
  searchView,
  selectedOptions,
  seriesLabel,
  seriesName,
  showInReview,
  showModelTemplateHeader,
  showSubmitted,
  isWarningOpen,
  hideWarning,
  handleShowSearch,
  handleClearFunctionalGruopFilters,
}) => (
  <div className={styles.modelDetails}>
    <div className={headerStyles}>
      <div className={styles.modelNavLinks}>
        <h1 className={styles.seriesTitle}>
          {seriesName} {seriesLabel}
        </h1>
        <div className={styles.modelNavLinksRight}>
          {previousModelId && <ModelNavLink modelId={previousModelId} />}
          {nextModelId && <ModelNavLink modelId={nextModelId} right />}
          <div className={styles.inCartContainer}>
            <CartNavLink />
          </div>
        </div>
      </div>
      {locked || !modelHasTemplates ? (
        <LockedModelHeader
          hasTemplates={modelHasTemplates}
          locked={locked}
          modelId={modelId}
        />
      ) : (
        <ModelHeader
          closeLocalSearch={closeLocalSearch}
          closeSearch={closeSearch}
          collapsedChart={collapsedChart}
          inReviewView={inReviewView}
          isClosed={isClosed}
          menuOpen={menuOpen}
          modelId={modelId}
          openChart={openChart}
          searchMenuVisibility={searchMenuVisibility}
          searchOptions={searchOptions}
          searchView={searchView}
          selectedOptions={selectedOptions}
          showInReview={showInReview}
          showSearch={handleShowSearch}
          showSubmitted={showSubmitted}
        />
      )}
    </div>

    <div className={chartStickyStyle}>
      {!locked && (
        <ModelPipeline
          closeChart={closeChart}
          collapsedChart={collapsedChart}
          hasTemplates={modelHasTemplates}
          modelId={modelId}
          openChart={openChart}
        />
      )}
      {showModelTemplateHeader && (
        <ModelTemplateHeader
          closeLocalSearch={closeLocalSearch}
          closeSearch={closeSearch}
          inReviewView={inReviewView}
          isClosed={isClosed}
          menuOpen={menuOpen}
          modelId={modelId}
          searchMenuVisibility={searchMenuVisibility}
          searchOptions={searchOptions}
          searchView={searchView}
          selectedOptions={selectedOptions}
          showInReview={showInReview}
          showSearch={handleShowSearch}
          showSubmitted={showSubmitted}
        />
      )}
    </div>

    {modelTemplatesLoading ? (
      <Loading />
    ) : (
      <Model
        chartSticky={chartSticky}
        collapsedChart={collapsedChart}
        hasScrolled={hasScrolled}
        inReviewView={inReviewView}
        isClosed={isClosed}
        locked={locked}
        modelId={modelId}
        scrollTop={scrollTop}
        searchView={searchView}
        selectedOptions={selectedOptions}
        closeGolbalSearch={closeSearch}
      />
    )}
    {!modelHasTemplates && !modelTemplatesLoading && (
      <div className={styles.noTemplates}>{noTemplates}</div>
    )}
    {isWarningOpen && (
      <Warning
        isOpen={true}
        primaryAction={hideWarning}
        handleClose={hideWarning}
        secondaryAction={handleClearFunctionalGruopFilters}
      />
    )}
  </div>
);

export default enhance(SeriesDetail);
